module.exports = __webpack_public_path__ + "img/apple-icon-57x57.fda8b42.png";